import trophy from "../../../../assets/img/homeV2/Trophy.png";
import "./FeaturesCards.css";
import { Link } from "react-router-dom";

/**
 * Feature card data — each item drives one card.
 * Add or remove entries here to change the card grid.
 * Set `overlayImage` to layer an extra image on top.
 */
const FEATURES = [
  {
    id: "interactive-maps",
    image: `${process.env.REACT_APP_CDN_URL}/static/homev2/Interactive-Maps.aa579c84bec858963868.png`,
    title: "Interactive maps",
    subtitle: "Your route to Indian Culture",
  },
  {
    id: "education-videos",
    image: `${process.env.REACT_APP_CDN_URL}/static/homev2/Education-Videos.8395e127911c6a9fb8c5.png`,
    title: "Education Videos",
    subtitle: "Stories of India's history and heritage",
  },
  {
    id: "quizzes-trophies",
    image: `${process.env.REACT_APP_CDN_URL}/static/homev2/Quizzes-Trophies.387dba1f7fffd7d28b96.png`,
    title: "Quizzes & Trophies",
    subtitle: "Get rewarded for your hard work",
    overlayImage: trophy,
  },
];

/**
 * FeaturesCards — 3-column card grid showcasing platform features.
 * Data-driven: update the FEATURES array above to modify content.
 */
export const FeaturesCards = () => {
  return (
    <section className="featuresCards" id="features-cards">
      <div className="featuresCards__container">
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.id} {...feature} />
        ))}
      </div>
    </section>
  );
};

/** Single feature card */
const FeatureCard = ({ id, image, title, subtitle, overlayImage }) => (
  <div className="featuresCards__card" id={`feature-card-${id}`}>
    <Link to="/student/start-your-quest">
    <div className="featuresCards__imageWrap">
      <img src={image} alt={title} className="featuresCards__image" />
      {overlayImage && (
        <img
          src={overlayImage}
          alt={`${title} overlay`}
          className="featuresCards__overlay"
        />
      )}
    </div>
    </Link>
    <h3 className="featuresCards__title">{title}</h3>
    <p className="featuresCards__subtitle">{subtitle}</p>
  </div>
);
